export const NON_TOKEN_ADDRESS = '0x0000000000000000000000000000000000000000'
export const ETH = NON_TOKEN_ADDRESS

/* eslint-disable key-spacing, quotes */
export const ERC20_SYMBOL_BYTES32_ABI = [
  {
    "constant":true,
    "inputs":[],
    "name":"symbol",
    "outputs":[
      {
        "name":"",
        "type":"bytes32"
      }
    ],
    "payable":false,
    "stateMutability":"view",
    "type":"function"
  }
]

export const ERC20_SYMBOL_DECIMALS_ABI = [
  {
    "constant":true,
    "inputs":[],
    "name":"decimals",
    "outputs":[
      {
        "name":"",
        "type":"uint8"
      }
    ],
    "payable":false,
    "stateMutability":"view",
    "type":"function"
  },
  {
    "constant":true,
    "inputs":[],
    "name":"symbol",
    "outputs":[
      {
        "name":"",
        "type":"string"
      }
    ],
    "payable":false,
    "stateMutability":"view",
    "type":"function"
  }
]
/* eslint-enable key-spacing, quotes */
